
import { Component } from '@angular/core'; 

import { FileUploader } from 'ng2-file-upload';
 
import { CommonService } from '../_Services/common.service';
import { DebtService } from '../_Services/debt.service';
import { Router, ActivatedRoute } from '@angular/router';  
import { Globals } from '../_Globals/globals'; 
const URL = 'http://192.168.4.200:8080/dmcs/backend/debt_importeds/add';
//const URL = 'http://localhost/col/backend/debt_importeds/add';

@Component({
	selector: 'simple-demo',
    templateUrl: 'import.component.html'
})
export class ImportComponent { 
 	
 	error = '';

 	msg = ''; 

	constructor(private router: Router, private route:ActivatedRoute, private commonService: CommonService, private debtService: DebtService, private globals: Globals) {
		this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
			var responsePath = JSON.parse(response);
			console.log(responsePath);
			this.error = '';
			if(responsePath.status === false) {
				this.error = responsePath.message;
			} else {
				if(responsePath.type == 1) {
					this.msg = 'Assigning debt. Please wait...';
					this.debtService.assignDebt(responsePath.debt_imported_id).subscribe(result => {
			            if (result.status === true) {
			            	this.msg = 'Saving vehicles. Please wait...';
			            	this.debtService.addVehicle(responsePath.debt_imported_id).subscribe(result => {
					            if (result.status === true) {
					            	this.msg = 'Process completed. You will be redirect...';
					                this.router.navigate(['/debts/receivable']); 
					            } else {
					                this.error = 'System failed to assign debt data'; 
					            }
					        }); 
		 
			            } else {
			                this.error = 'System failed to assign debt data'; 
			            }
			        }); 		
				} else {
					this.msg = 'Assigning debt. Please wait...';
					this.debtService.insertBlondalToDebt(responsePath.debt_imported_id).subscribe(result => {
			            if (result.status === true) {
			            	this.msg = 'Saving payment history. Please wait...';
			            	this.debtService.insertBlondalHistory(responsePath.debt_imported_id).subscribe(result => {
					            if (result.status === true) { 
					            	this.msg = 'Process completed. You will be redirect...';
					                this.router.navigate(['/debts/receivable']);  
					            } else {
					                this.error = 'System failed to assign debt data'; 
					            }
					        }); 
		 
			            } else {
			                this.error = 'System failed to assign debt data'; 
			            }
			        });  
				}
				
			}
			
		};
	}

	originating = '';

	ofs = []; 
  	onChange(value) {
	    this.originating = value;
	    console.log(value);
  	}

	public uploader:FileUploader = new FileUploader(
		{
			url: this.globals.api_url + 'debt_importeds/add',
			method: "POST",
			itemAlias: 'data[DebtImported][file]'
		}
	);
	 
	ngAfterViewInit() {
		this.uploader.onAfterAddingFile = (item => {
			item.withCredentials = false;
			if(this.originating == '') {
				alert('Please select Originating Financial Service');
			}
		});
	} 

	ngOnInit() {
		// Upload form
		this.uploader.onBuildItemForm = (item, form) => {
			form.append("data[DebtImported][name]", this.originating);
			form.append("data[DebtImported][dir]", '');
			form.append("data[DebtImported][finance_service_id]", this.originating);
		};

		// common ofs
		this.commonService.getOfs().subscribe(result => {
                console.log(result);
                this.ofs = result;
            }); 
	}
}


// WEBPACK FOOTER //
// ./src/app/debts/import.component.ts